import type { default as TombstoneReasonType } from '../store/schema/TombstoneReasonType';
import { getStore } from '../store/Store';

/**
 * Returns tombstoned reasons for a conversation(instanceKey)
 * @param instanceKey - the instanceKey to check
 * @param folderId for the instanceKey
 * @returns the array of TombstoneReasonType if it exists, undefined otherwise
 */
const getTombstonedReasons = function getTombstonedReasons(
    instanceKey: string,
    folderId: string
): TombstoneReasonType[] {
    const folderTombstoneMap = getStore().folderTombstoneMap;

    if (folderId in folderTombstoneMap) {
        const conversationTombstoneMap = folderTombstoneMap[folderId];
        const tombstoneReasonsForRow = conversationTombstoneMap[instanceKey];
        if (tombstoneReasonsForRow) {
            return tombstoneReasonsForRow;
        }
    }

    /**
     * This row may not have been tombstoned
     */
    return [];
};

export default getTombstonedReasons;
